
import { PlayIcon } from "@heroicons/react/20/solid"

const PlayButton = () => (
  <div className="absolute text-white transition duration-300 ease-in-out transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 drop-shadow-md hover:drop-shadow-xl hover:scale-110 active:text-slate-400">
    <PlayIcon className="w-16 h-16 " />
  </div>
);

export default PlayButton
